import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      nav: {
        home: "Accueil",
        circuits4x4: "Circuits 4x4",
        trekking: "Trekking",
        map: "Carte Interactive",
        team: "Notre Équipe",
        testimonials: "Témoignages",
        contact: "Contact",
        book: "Réserver"
      },
      // Hero
      hero: {
        title: "L'Âme du Sahara Marocain",
        subtitle: "Vivez une aventure authentique au cœur du désert. Circuits 4x4 et treks guidés par des experts sahraouis.",
        cta: "Découvrir nos circuits",
        scroll: "Défiler"
      },
      // Circuits
      circuits: {
        title: "Nos Aventures",
        subtitle: "Explorez le Sahara à votre rythme",
        intro: "Depuis plus de 20 ans, nous parcourons les pistes du grand sud marocain. Nos circuits vous emmènent des portes de Marrakech jusqu'aux majestueuses dunes d'Erg Chegaga, à travers les vallées du Drâa, les gorges spectaculaires et les oasis cachées. Chaque itinéraire est conçu pour vous faire découvrir l'âme authentique du Sahara, loin des sentiers touristiques.",
        all: "Tous",
        type4x4: "4x4",
        typeTrekking: "Trekking",
        duration: "jours",
        from: "À partir de",
        perPerson: "par personne",
        viewDetails: "Voir le détail",
        difficulty: {
          easy: "Facile",
          moderate: "Modéré",
          challenging: "Sportif"
        },
        includes: "Ce qui est inclus",
        itinerary: "Itinéraire",
        day: "Jour",
        highlights: "Points forts",
        bookNow: "Réserver maintenant",
        maxGroup: "Groupe max",
        persons: "personnes",
        departure: "Départ de"
      },
      // Team
      team: {
        title: "Notre Équipe",
        subtitle: "Des passionnés du désert à votre service",
        intro: "Nés dans le désert et bercés par ses mystères, nos guides sont de véritables enfants du Sahara. Leur connaissance intime des dunes, leur respect des traditions nomades et leur passion communicative font de chaque voyage une expérience humaine inoubliable. Avec eux, vous ne serez pas de simples touristes, mais des invités privilégiés dans leur pays de sable et d'étoiles.",
        experience: "ans d'expérience"
      },
      // Testimonials
      testimonials: {
        title: "Ce qu'ils disent",
        subtitle: "Les retours de nos voyageurs",
        intro: "Chaque voyage laisse une empreinte unique. Découvrez les témoignages de ceux qui ont vécu l'aventure saharienne avec nous : des familles aux aventuriers solitaires, des photographes en quête de lumière aux chercheurs de sérénité. Leurs mots racontent bien mieux que nous la magie des nuits étoilées, la chaleur de l'accueil berbère et l'émerveillement face à l'immensité dorée des dunes."
      },
      // Contact
      contact: {
        title: "Contactez-nous",
        subtitle: "Une question ? Un projet de voyage ?",
        intro: "Notre équipe est à votre écoute pour construire ensemble votre voyage idéal. Que vous souhaitiez un circuit sur mesure, des informations sur nos départs ou simplement des conseils pour préparer votre aventure, n'hésitez pas à nous écrire. Nous répondons généralement sous 24 heures et nous ferons un plaisir de vous accompagner dans la préparation de votre séjour au Sahara.",
        name: "Votre nom",
        email: "Votre email",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Votre message",
        send: "Envoyer",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi"
      },
      // Booking
      booking: {
        title: "Réservation",
        participants: "Nombre de participants",
        date: "Date souhaitée",
        specialRequests: "Demandes spéciales",
        total: "Total",
        payNow: "Payer maintenant",
        paymentSuccess: "Paiement réussi !",
        paymentPending: "Paiement en cours...",
        paymentError: "Erreur de paiement",
        confirmationMessage: "Votre réservation est confirmée. Vous recevrez un email de confirmation."
      },
      // Map
      map: {
        title: "Carte du Sahara",
        subtitle: "Explorez nos itinéraires",
        intro: "De la ville ocre de Marrakech aux immenses dunes d'Erg Chegaga, explorez visuellement nos territoires d'aventure. Cette carte interactive vous permet de découvrir les étapes clés de nos circuits : kasbahs millénaires, vallées verdoyantes, villages nomades et mers de sable. Cliquez sur un itinéraire pour en découvrir les détails et planifier votre prochaine escapade saharienne.",
        routes: "Itinéraires",
        destinations: "Destinations",
        city: "Ville",
        village: "Village",
        dunes: "Dunes",
        kasbah: "Kasbah",
        valley: "Vallée",
        gorge: "Gorges"
      },
      // Footer
      footer: {
        tagline: "L'aventure authentique du Sahara marocain",
        quickLinks: "Liens rapides",
        contact: "Contact",
        followUs: "Suivez-nous",
        rights: "Tous droits réservés"
      },
      // Common
      common: {
        loading: "Chargement...",
        error: "Une erreur est survenue",
        retry: "Réessayer",
        close: "Fermer",
        back: "Retour"
      },
      // Stages & Retreats
      stages: {
        title: "Stages & Retraites",
        subtitle: "Ressourcez-vous au cœur du désert",
        intro: "Le désert est depuis toujours un lieu de ressourcement et de transformation intérieure. Nos stages et retraites vous offrent un cadre exceptionnel pour vous reconnecter à l'essentiel : yoga au lever du soleil sur les dunes, méditation sous un ciel étoilé, ateliers artistiques inspirés par les paysages, moments de partage autour du feu. Laissez la magie du Sahara opérer et repartez transformé.",
        categories: {
          yoga: "Yoga",
          meditation: "Méditation",
          art: "Art & Créativité",
          music: "Musique",
          wellness: "Bien-être",
          spiritual: "Spiritualité"
        },
        duration: "jours",
        from: "À partir de",
        perPerson: "par personne",
        maxParticipants: "participants max",
        viewDetails: "Voir le détail",
        program: "Programme",
        includes: "Ce qui est inclus",
        contact: "Contacter l'organisateur",
        bookNow: "Réserver",
        organizedBy: "Organisé par",
        location: "Lieu",
        nextDates: "Prochaines dates"
      },
      // Gallery
      gallery: {
        title: "Galerie",
        subtitle: "Découvrez le Sahara en images",
        intro: "Les mots ne suffisent pas à décrire la beauté du Sahara. Laissez-vous transporter par ces images capturées au fil de nos aventures : l'or des dunes au coucher du soleil, les sourires des nomades, l'immensité silencieuse du désert, les oasis surgissant comme des mirages. Chaque photo raconte une histoire, un moment de grâce volé à l'éternité saharienne.",
        categories: {
          all: "Tout",
          circuits: "Circuits",
          stages: "Stages",
          team: "Équipe",
          general: "Général"
        },
        photos: "Photos",
        videos: "Vidéos"
      },
      // Blog
      blog: {
        title: "Blog",
        subtitle: "Récits et conseils du désert",
        intro: "Plongez dans l'univers fascinant du Sahara à travers nos articles. Récits de voyage, conseils pratiques pour préparer votre aventure, découverte de la culture berbère et nomade, secrets des oasis... Notre blog est une fenêtre ouverte sur le désert, pour rêver, apprendre et vous préparer à vivre votre propre histoire saharienne.",
        categories: {
          all: "Tous",
          travel: "Voyage",
          culture: "Culture",
          tips: "Conseils",
          stories: "Récits",
          news: "Actualités"
        },
        readMore: "Lire la suite",
        by: "Par",
        publishedOn: "Publié le",
        views: "vues",
        relatedPosts: "Articles similaires",
        sharePost: "Partager"
      },
      // CGV - Terms and Conditions
      cgv: {
        pageTitle: "Conditions Générales de Vente",
        subtitle: "Informations légales",
        tabs: {
          tarifs: "Tarifs",
          reservation: "Réservation",
          paiement: "Paiement",
          annulation: "Annulation",
          assurance: "Assurance",
          responsabilite: "Responsabilité",
          litiges: "Litiges"
        },
        nav: {
          previous: "Précédent",
          next: "Suivant"
        },
        contact: {
          title: "Des questions ?",
          subtitle: "Notre équipe est à votre disposition pour répondre à toutes vos interrogations."
        },
        lastUpdate: "Dernière mise à jour",
        // Section 1 - Tarifs
        tarifs: {
          title: "Tarifs et Services Inclus",
          intro: "Les tarifs de nos séjours sont indiqués sur chaque page de circuit ou trek, dans l'onglet \"Tarifs\".",
          priceInfo: "Les prix sont exprimés en euros (€) et par personne",
          groupInfo: "pour des groupes de 4 personnes minimum. Pour les groupes de moins de 4 personnes, veuillez nous contacter.",
          included: {
            title: "Services généralement inclus :",
            items: [
              "Transport aller-retour depuis la ville de départ",
              "Hébergement en bivouac ou camp de luxe selon la formule",
              "Pension complète (repas, eau, thé à la menthe)",
              "Accompagnement par un guide professionnel",
              "Équipement de bivouac (tentes, matelas, couvertures)",
              "Dromadaires pour le transport des bagages (treks)"
            ]
          },
          notIncluded: {
            title: "Non inclus dans le prix :",
            items: [
              "Les vols internationaux et transferts aéroport",
              "Les boissons autres que celles servies aux repas",
              "Les entrées des sites touristiques",
              "Les activités optionnelles (quad, sandboard...)",
              "Les pourboires (environ 10%)",
              "L'assurance voyage et rapatriement"
            ]
          },
          childRate: "Une réduction est accordée aux enfants de moins de 12 ans. Les enfants de moins de 2 ans sont gratuits (limité à un enfant par famille)."
        },
        // Section 2 - Reservation
        reservation: {
          title: "Réservation",
          minParticipants: "Les départs de treks et circuits sont confirmés à partir de",
          minPersons: "2 personnes minimum",
          methodsIntro: "Les réservations peuvent être effectuées :",
          methods: [
            "En ligne via notre site internet",
            "Par email",
            "Par téléphone"
          ],
          confirmation: {
            title: "Confirmation :",
            text: "Votre réservation sera définitive à réception d'un acompte de",
            deposit: "30% du montant total",
            details: "Un récapitulatif vous sera envoyé avant le départ."
          }
        },
        // Section 3 - Payment
        paiement: {
          title: "Modalités de Paiement",
          intro: "Le paiement s'effectue en deux temps :",
          deposit: {
            title: "1. Acompte (30%)",
            text: "À verser lors de la réservation par carte bancaire (Stripe) ou virement."
          },
          balance: {
            title: "2. Solde (70%)",
            text: "À régler 30 jours avant le départ, ou sur place en espèces."
          },
          methodsTitle: "Moyens de paiement acceptés :",
          methods: [
            "Carte bancaire (Visa, Mastercard) via Stripe",
            "Virement bancaire",
            "Espèces sur place (euros ou dirhams)"
          ]
        },
        // Section 4 - Cancellation
        annulation: {
          title: "Conditions d'Annulation",
          intro: "En cas d'annulation de votre part :",
          tableHeaders: {
            delay: "Délai",
            fees: "Frais"
          },
          rows: [
            { delay: "+ de 30 jours", fees: "Remboursé (- 50€/pers.)" },
            { delay: "30 à 21 jours", fees: "30%" },
            { delay: "20 à 8 jours", fees: "50%" },
            { delay: "7 à 2 jours", fees: "75%" },
            { delay: "- de 48h", fees: "100%" }
          ],
          important: "Nous recommandons de souscrire une assurance annulation.",
          byUs: {
            title: "Annulation par XploreSahara :",
            text: "Remboursement intégral ou nouvelle date proposée."
          }
        },
        // Section 5 - Insurance
        assurance: {
          title: "Assurance et Santé",
          certifyIntro: "En vous inscrivant, vous certifiez que :",
          certifyItems: [
            "Aucun problème de santé ne vous empêche de participer",
            "Vous êtes assuré(e) pour votre responsabilité civile",
            "Vous disposez d'une assurance rapatriement pour le Maroc"
          ],
          medical: {
            title: "Recommandations médicales",
            text: "Les treks nécessitent une bonne condition physique. Consultez votre médecin avant le départ et emportez vos médicaments personnels."
          },
          recommended: "Assurance recommandée : Annulation, rapatriement, frais médicaux et bagages."
        },
        // Section 6 - Responsibility
        responsabilite: {
          title: "Responsabilité",
          program: {
            title: "Modification du programme :",
            text: "Le programme peut être adapté selon les conditions météo ou la sécurité. Cela ne donne pas lieu à remboursement."
          },
          belongings: {
            title: "Objets personnels :",
            text: "XploreSahara décline toute responsabilité en cas de perte, vol ou détérioration de vos effets personnels."
          },
          waiver: "En vous inscrivant, vous renoncez à toute réclamation en cas de maladie, accident ou dommage survenu pendant le séjour, sauf faute avérée de notre part."
        },
        // Section 7 - Disputes
        litiges: {
          title: "Réclamations et Litiges",
          claim: {
            intro: "En cas de réclamation, contactez-nous dans les",
            delay: "30 jours suivant la fin de votre séjour",
            details: "par email en décrivant les faits et joignant tout justificatif."
          },
          response: "Nous nous engageons à répondre sous 15 jours ouvrés et à rechercher une solution amiable.",
          jurisdiction: "À défaut d'accord amiable, tout litige sera soumis aux tribunaux compétents conformément au droit marocain.",
          contactTitle: "Contact réclamations :",
          address: "Adresse"
        }
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        circuits4x4: "4x4 Circuits",
        trekking: "Trekking",
        map: "Interactive Map",
        team: "Our Team",
        testimonials: "Testimonials",
        contact: "Contact",
        book: "Book"
      },
      hero: {
        title: "The Soul of the Moroccan Sahara",
        subtitle: "Experience an authentic adventure in the heart of the desert. 4x4 circuits and treks guided by Saharan experts.",
        cta: "Discover our circuits",
        scroll: "Scroll"
      },
      circuits: {
        title: "Our Adventures",
        subtitle: "Explore the Sahara at your own pace",
        intro: "For over 20 years, we have been exploring the trails of southern Morocco. Our tours take you from the gates of Marrakech to the majestic dunes of Erg Chegaga, through the Draa valleys, spectacular gorges and hidden oases. Each itinerary is designed to reveal the authentic soul of the Sahara, far from tourist paths.",
        all: "All",
        type4x4: "4x4",
        typeTrekking: "Trekking",
        duration: "days",
        from: "From",
        perPerson: "per person",
        viewDetails: "View details",
        difficulty: {
          easy: "Easy",
          moderate: "Moderate",
          challenging: "Challenging"
        },
        includes: "What's included",
        itinerary: "Itinerary",
        day: "Day",
        highlights: "Highlights",
        bookNow: "Book now",
        maxGroup: "Max group",
        persons: "persons",
        departure: "Departure from"
      },
      team: {
        title: "Our Team",
        subtitle: "Desert enthusiasts at your service",
        intro: "Born in the desert and raised with its mysteries, our guides are true children of the Sahara. Their intimate knowledge of the dunes, their respect for nomadic traditions and their infectious passion make every journey an unforgettable human experience. With them, you won't be mere tourists, but privileged guests in their land of sand and stars.",
        experience: "years of experience"
      },
      testimonials: {
        title: "What they say",
        subtitle: "Feedback from our travelers",
        intro: "Every journey leaves a unique imprint. Discover the testimonials of those who have experienced the Saharan adventure with us: from families to solo adventurers, photographers seeking light to seekers of serenity. Their words tell better than we could the magic of starry nights, the warmth of Berber hospitality and the wonder of the golden immensity of the dunes."
      },
      contact: {
        title: "Contact Us",
        subtitle: "A question? A travel project?",
        intro: "Our team is here to help you build your ideal trip. Whether you want a customized tour, information about our departures or simply advice on preparing your adventure, don't hesitate to write to us. We usually respond within 24 hours and will be delighted to assist you in preparing your stay in the Sahara.",
        name: "Your name",
        email: "Your email",
        phone: "Phone",
        subject: "Subject",
        message: "Your message",
        send: "Send",
        success: "Message sent successfully!",
        error: "Error sending message"
      },
      booking: {
        title: "Booking",
        participants: "Number of participants",
        date: "Preferred date",
        specialRequests: "Special requests",
        total: "Total",
        payNow: "Pay now",
        paymentSuccess: "Payment successful!",
        paymentPending: "Payment in progress...",
        paymentError: "Payment error",
        confirmationMessage: "Your booking is confirmed. You will receive a confirmation email."
      },
      map: {
        title: "Sahara Map",
        subtitle: "Explore our routes",
        intro: "From the ochre city of Marrakech to the immense dunes of Erg Chegaga, visually explore our adventure territories. This interactive map allows you to discover the key stages of our tours: ancient kasbahs, green valleys, nomadic villages and seas of sand. Click on an itinerary to discover details and plan your next Saharan escape.",
        routes: "Routes",
        destinations: "Destinations",
        city: "City",
        village: "Village",
        dunes: "Dunes",
        kasbah: "Kasbah",
        valley: "Valley",
        gorge: "Gorges"
      },
      footer: {
        tagline: "The authentic adventure of the Moroccan Sahara",
        quickLinks: "Quick Links",
        contact: "Contact",
        followUs: "Follow Us",
        rights: "All rights reserved"
      },
      common: {
        loading: "Loading...",
        error: "An error occurred",
        retry: "Retry",
        close: "Close",
        back: "Back"
      },
      stages: {
        title: "Stages & Retreats",
        subtitle: "Recharge in the heart of the desert",
        intro: "The desert has always been a place of renewal and inner transformation. Our workshops and retreats offer you an exceptional setting to reconnect with what matters: yoga at sunrise on the dunes, meditation under a starry sky, artistic workshops inspired by the landscapes, moments of sharing around the fire. Let the magic of the Sahara work and return transformed.",
        categories: {
          yoga: "Yoga",
          meditation: "Meditation",
          art: "Art & Creativity",
          music: "Music",
          wellness: "Wellness",
          spiritual: "Spirituality"
        },
        duration: "days",
        from: "From",
        perPerson: "per person",
        maxParticipants: "max participants",
        viewDetails: "View details",
        program: "Program",
        includes: "What's included",
        contact: "Contact organizer",
        bookNow: "Book now",
        organizedBy: "Organized by",
        location: "Location",
        nextDates: "Next dates"
      },
      gallery: {
        title: "Gallery",
        subtitle: "Discover the Sahara in images",
        intro: "Words cannot describe the beauty of the Sahara. Let yourself be transported by these images captured throughout our adventures: the gold of dunes at sunset, the smiles of nomads, the silent immensity of the desert, oases emerging like mirages. Each photo tells a story, a moment of grace stolen from Saharan eternity.",
        categories: {
          all: "All",
          circuits: "Circuits",
          stages: "Stages",
          team: "Team",
          general: "General"
        },
        photos: "Photos",
        videos: "Videos"
      },
      blog: {
        title: "Blog",
        subtitle: "Stories and tips from the desert",
        intro: "Dive into the fascinating world of the Sahara through our articles. Travel stories, practical tips to prepare your adventure, discovery of Berber and nomadic culture, oasis secrets... Our blog is a window to the desert, to dream, learn and prepare yourself to live your own Saharan story.",
        categories: {
          all: "All",
          travel: "Travel",
          culture: "Culture",
          tips: "Tips",
          stories: "Stories",
          news: "News"
        },
        readMore: "Read more",
        by: "By",
        publishedOn: "Published on",
        views: "views",
        relatedPosts: "Related posts",
        sharePost: "Share"
      },
      // CGV - Terms and Conditions
      cgv: {
        pageTitle: "Terms and Conditions",
        subtitle: "Legal information",
        tabs: {
          tarifs: "Rates",
          reservation: "Booking",
          paiement: "Payment",
          annulation: "Cancellation",
          assurance: "Insurance",
          responsabilite: "Liability",
          litiges: "Disputes"
        },
        nav: {
          previous: "Previous",
          next: "Next"
        },
        contact: {
          title: "Any questions?",
          subtitle: "Our team is available to answer all your questions."
        },
        lastUpdate: "Last updated",
        tarifs: {
          title: "Rates and Included Services",
          intro: "The rates for our trips are displayed on each circuit or trek page, under the \"Rates\" tab.",
          priceInfo: "Prices are in euros (€) and per person",
          groupInfo: "for groups of 4 people minimum. For smaller groups, please contact us.",
          included: {
            title: "Generally included services:",
            items: [
              "Round-trip transportation from departure city",
              "Accommodation in bivouac or luxury camp",
              "Full board (meals, water, mint tea)",
              "Professional guide accompaniment",
              "Bivouac equipment (tents, mattresses, blankets)",
              "Camels for luggage transport (treks)"
            ]
          },
          notIncluded: {
            title: "Not included:",
            items: [
              "International flights and airport transfers",
              "Beverages other than those served at meals",
              "Tourist site entrance fees",
              "Optional activities (quad, sandboard...)",
              "Tips (approximately 10%)",
              "Travel and repatriation insurance"
            ]
          },
          childRate: "A discount is offered for children under 12. Children under 2 are free (limited to one per family)."
        },
        reservation: {
          title: "Booking",
          minParticipants: "Trek and circuit departures are confirmed from",
          minPersons: "2 people minimum",
          methodsIntro: "Reservations can be made:",
          methods: [
            "Online via our website",
            "By email",
            "By phone"
          ],
          confirmation: {
            title: "Confirmation:",
            text: "Your booking will be confirmed upon receipt of a deposit of",
            deposit: "30% of the total amount",
            details: "A summary will be sent to you before departure."
          }
        },
        paiement: {
          title: "Payment Methods",
          intro: "Payment is made in two installments:",
          deposit: {
            title: "1. Deposit (30%)",
            text: "To be paid at booking by credit card (Stripe) or bank transfer."
          },
          balance: {
            title: "2. Balance (70%)",
            text: "To be paid 30 days before departure, or on site in cash."
          },
          methodsTitle: "Accepted payment methods:",
          methods: [
            "Credit card (Visa, Mastercard) via Stripe",
            "Bank transfer",
            "Cash on site (euros or dirhams)"
          ]
        },
        annulation: {
          title: "Cancellation Policy",
          intro: "In case of cancellation on your part:",
          tableHeaders: {
            delay: "Notice",
            fees: "Fees"
          },
          rows: [
            { delay: "More than 30 days", fees: "Refunded (- €50/pers.)" },
            { delay: "30 to 21 days", fees: "30%" },
            { delay: "20 to 8 days", fees: "50%" },
            { delay: "7 to 2 days", fees: "75%" },
            { delay: "Less than 48h", fees: "100%" }
          ],
          important: "We recommend taking out cancellation insurance.",
          byUs: {
            title: "Cancellation by XploreSahara:",
            text: "Full refund or new date offered."
          }
        },
        assurance: {
          title: "Insurance and Health",
          certifyIntro: "By registering, you certify that:",
          certifyItems: [
            "No health issues prevent you from participating",
            "You are insured for civil liability",
            "You have valid repatriation insurance for Morocco"
          ],
          medical: {
            title: "Medical recommendations",
            text: "Treks require good physical condition. Consult your doctor before departure and bring your personal medications."
          },
          recommended: "Recommended insurance: Cancellation, repatriation, medical expenses and luggage."
        },
        responsabilite: {
          title: "Liability",
          program: {
            title: "Program modifications:",
            text: "The program may be adapted based on weather or safety conditions. This does not entitle to a refund."
          },
          belongings: {
            title: "Personal belongings:",
            text: "XploreSahara declines all responsibility for loss, theft or damage to your personal effects."
          },
          waiver: "By registering, you waive any claim in case of illness, accident or damage during the trip, except in case of proven fault on our part."
        },
        litiges: {
          title: "Claims and Disputes",
          claim: {
            intro: "In case of complaint, contact us within",
            delay: "30 days following the end of your stay",
            details: "by email describing the facts and attaching any supporting documents."
          },
          response: "We commit to responding within 15 business days and seeking an amicable solution.",
          jurisdiction: "Failing amicable agreement, any dispute will be submitted to competent courts under Moroccan law.",
          contactTitle: "Claims contact:",
          address: "Address"
        }
      }
    }
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        circuits4x4: "جولات 4x4",
        trekking: "المشي",
        map: "الخريطة التفاعلية",
        team: "فريقنا",
        testimonials: "الشهادات",
        contact: "اتصل بنا",
        book: "احجز"
      },
      hero: {
        title: "روح الصحراء المغربية",
        subtitle: "عش مغامرة أصيلة في قلب الصحراء. جولات 4x4 ورحلات مشي بإرشاد خبراء صحراويين.",
        cta: "اكتشف جولاتنا",
        scroll: "مرر"
      },
      circuits: {
        title: "مغامراتنا",
        subtitle: "استكشف الصحراء بإيقاعك",
        intro: "منذ أكثر من 20 عامًا، نجوب مسارات الجنوب المغربي الكبير. جولاتنا تأخذك من أبواب مراكش إلى كثبان عرق الشقاقة المهيبة، عبر وديان درعة والأخاديد الرائعة والواحات المخفية. كل مسار مصمم ليكشف لك روح الصحراء الأصيلة، بعيدًا عن المسارات السياحية.",
        all: "الكل",
        type4x4: "4x4",
        typeTrekking: "مشي",
        duration: "أيام",
        from: "ابتداءً من",
        perPerson: "للشخص",
        viewDetails: "عرض التفاصيل",
        difficulty: {
          easy: "سهل",
          moderate: "متوسط",
          challenging: "رياضي"
        },
        includes: "ما يشمله",
        itinerary: "برنامج الرحلة",
        day: "اليوم",
        highlights: "أبرز المحطات",
        bookNow: "احجز الآن",
        maxGroup: "الحد الأقصى للمجموعة",
        persons: "أشخاص",
        departure: "المغادرة من"
      },
      team: {
        title: "فريقنا",
        subtitle: "عشاق الصحراء في خدمتك",
        intro: "ولدوا في الصحراء وترعرعوا بين أسرارها، مرشدونا هم أبناء الصحراء الحقيقيون. معرفتهم العميقة بالكثبان، واحترامهم للتقاليد البدوية، وشغفهم المعدي يجعل كل رحلة تجربة إنسانية لا تُنسى. معهم، لن تكون مجرد سائح، بل ضيفًا مميزًا في أرض الرمال والنجوم.",
        experience: "سنوات من الخبرة"
      },
      testimonials: {
        title: "ماذا يقولون",
        subtitle: "آراء مسافرينا",
        intro: "كل رحلة تترك بصمة فريدة. اكتشف شهادات من عاشوا مغامرة الصحراء معنا: من العائلات إلى المغامرين المنفردين، من المصورين الباحثين عن الضوء إلى الباحثين عن السكينة. كلماتهم تروي أفضل منا سحر الليالي المرصعة بالنجوم، ودفء الضيافة الأمازيغية، والدهشة أمام اتساع الكثبان الذهبية."
      },
      contact: {
        title: "اتصل بنا",
        subtitle: "سؤال؟ مشروع سفر؟",
        intro: "فريقنا في خدمتك لبناء رحلتك المثالية معًا. سواء كنت تريد جولة مخصصة، أو معلومات عن مواعيد السفر، أو مجرد نصائح للتحضير لمغامرتك، لا تتردد في الكتابة إلينا. نرد عادة خلال 24 ساعة ويسعدنا مساعدتك في التحضير لإقامتك في الصحراء.",
        name: "اسمك",
        email: "بريدك الإلكتروني",
        phone: "الهاتف",
        subject: "الموضوع",
        message: "رسالتك",
        send: "إرسال",
        success: "تم إرسال الرسالة بنجاح!",
        error: "خطأ في الإرسال"
      },
      booking: {
        title: "الحجز",
        participants: "عدد المشاركين",
        date: "التاريخ المفضل",
        specialRequests: "طلبات خاصة",
        total: "المجموع",
        payNow: "ادفع الآن",
        paymentSuccess: "تم الدفع بنجاح!",
        paymentPending: "جاري الدفع...",
        paymentError: "خطأ في الدفع",
        confirmationMessage: "تم تأكيد حجزك. ستتلقى بريدًا إلكترونيًا للتأكيد."
      },
      map: {
        title: "خريطة الصحراء",
        subtitle: "استكشف مساراتنا",
        intro: "من مدينة مراكش الحمراء إلى كثبان عرق الشقاقة الشاسعة، استكشف بصريًا أراضي مغامرتنا. هذه الخريطة التفاعلية تتيح لك اكتشاف المحطات الرئيسية في جولاتنا: قصبات عريقة، وديان خضراء، قرى بدوية، وبحار من الرمال. انقر على مسار لاكتشاف تفاصيله والتخطيط لرحلتك الصحراوية القادمة.",
        routes: "المسارات",
        destinations: "الوجهات",
        city: "مدينة",
        village: "قرية",
        dunes: "كثبان",
        kasbah: "قصبة",
        valley: "وادي",
        gorge: "مضيق"
      },
      footer: {
        tagline: "المغامرة الأصيلة للصحراء المغربية",
        quickLinks: "روابط سريعة",
        contact: "اتصل بنا",
        followUs: "تابعنا",
        rights: "جميع الحقوق محفوظة"
      },
      common: {
        loading: "جاري التحميل...",
        error: "حدث خطأ",
        retry: "أعد المحاولة",
        close: "إغلاق",
        back: "رجوع"
      }
    }
  },
  nl: {
    translation: {
      nav: {
        home: "Home",
        circuits4x4: "4x4 Circuits",
        trekking: "Trekking",
        map: "Interactieve Kaart",
        team: "Ons Team",
        testimonials: "Getuigenissen",
        contact: "Contact",
        book: "Boeken"
      },
      hero: {
        title: "De Ziel van de Marokkaanse Sahara",
        subtitle: "Beleef een authentiek avontuur in het hart van de woestijn. 4x4 circuits en treks onder begeleiding van Sahara experts.",
        cta: "Ontdek onze circuits",
        scroll: "Scrollen"
      },
      circuits: {
        title: "Onze Avonturen",
        subtitle: "Verken de Sahara op uw eigen tempo",
        intro: "Al meer dan 20 jaar doorkruisen we de paden van het zuiden van Marokko. Onze circuits nemen u mee van de poorten van Marrakech naar de majestueuze duinen van Erg Chegaga, door de Draa-valleien, spectaculaire kloven en verborgen oases. Elk traject is ontworpen om u de authentieke ziel van de Sahara te laten ontdekken, ver van de toeristische routes.",
        all: "Alles",
        type4x4: "4x4",
        typeTrekking: "Trekking",
        duration: "dagen",
        from: "Vanaf",
        perPerson: "per persoon",
        viewDetails: "Details bekijken",
        difficulty: {
          easy: "Makkelijk",
          moderate: "Gemiddeld",
          challenging: "Uitdagend"
        },
        includes: "Wat is inbegrepen",
        itinerary: "Reisschema",
        day: "Dag",
        highlights: "Hoogtepunten",
        bookNow: "Nu boeken",
        maxGroup: "Max groep",
        persons: "personen",
        departure: "Vertrek vanuit"
      },
      team: {
        title: "Ons Team",
        subtitle: "Woestijn liefhebbers tot uw dienst",
        intro: "Geboren in de woestijn en opgegroeid met haar geheimen, zijn onze gidsen echte kinderen van de Sahara. Hun intieme kennis van de duinen, hun respect voor nomadische tradities en hun aanstekelijke passie maken van elke reis een onvergetelijke menselijke ervaring. Met hen bent u geen gewone toerist, maar een bevoorrechte gast in hun land van zand en sterren.",
        experience: "jaar ervaring"
      },
      testimonials: {
        title: "Wat ze zeggen",
        subtitle: "Feedback van onze reizigers",
        intro: "Elke reis laat een unieke indruk achter. Ontdek de getuigenissen van degenen die het Sahara-avontuur met ons hebben beleefd: van gezinnen tot solo-avonturiers, fotografen op zoek naar licht tot zoekers van sereniteit. Hun woorden vertellen beter dan wij de magie van sterrennachten, de warmte van Berberse gastvrijheid en de verwondering over de gouden oneindigheid van de duinen."
      },
      contact: {
        title: "Neem Contact Op",
        subtitle: "Een vraag? Een reisproject?",
        intro: "Ons team staat klaar om samen met u uw ideale reis samen te stellen. Of u nu een reis op maat wilt, informatie over onze vertrekdata of gewoon advies om uw avontuur voor te bereiden, aarzel niet om ons te schrijven. We reageren meestal binnen 24 uur en helpen u graag bij de voorbereiding van uw verblijf in de Sahara.",
        name: "Uw naam",
        email: "Uw email",
        phone: "Telefoon",
        subject: "Onderwerp",
        message: "Uw bericht",
        send: "Verzenden",
        success: "Bericht succesvol verzonden!",
        error: "Fout bij verzenden"
      },
      booking: {
        title: "Boeking",
        participants: "Aantal deelnemers",
        date: "Gewenste datum",
        specialRequests: "Speciale verzoeken",
        total: "Totaal",
        payNow: "Nu betalen",
        paymentSuccess: "Betaling geslaagd!",
        paymentPending: "Betaling in uitvoering...",
        paymentError: "Betalingsfout",
        confirmationMessage: "Uw boeking is bevestigd. U ontvangt een bevestigingsmail."
      },
      map: {
        title: "Sahara Kaart",
        subtitle: "Verken onze routes",
        intro: "Van de okeren stad Marrakech tot de immense duinen van Erg Chegaga, verken visueel onze avontuurlijke gebieden. Deze interactieve kaart laat u de belangrijkste etappes van onze circuits ontdekken: eeuwenoude kasbahs, groene valleien, nomadische dorpen en zandzeëen. Klik op een route om de details te ontdekken en uw volgende Sahara-ontsnapping te plannen.",
        routes: "Routes",
        destinations: "Bestemmingen",
        city: "Stad",
        village: "Dorp",
        dunes: "Duinen",
        kasbah: "Kasbah",
        valley: "Vallei",
        gorge: "Kloven"
      },
      footer: {
        tagline: "Het authentieke avontuur van de Marokkaanse Sahara",
        quickLinks: "Snelle Links",
        contact: "Contact",
        followUs: "Volg Ons",
        rights: "Alle rechten voorbehouden"
      },
      common: {
        loading: "Laden...",
        error: "Er is een fout opgetreden",
        retry: "Opnieuw proberen",
        close: "Sluiten",
        back: "Terug"
      }
    }
  },
  es: {
    translation: {
      nav: {
        home: "Inicio",
        circuits4x4: "Circuitos 4x4",
        trekking: "Trekking",
        map: "Mapa Interactivo",
        team: "Nuestro Equipo",
        testimonials: "Testimonios",
        contact: "Contacto",
        book: "Reservar"
      },
      hero: {
        title: "El Alma del Sahara Marroquí",
        subtitle: "Vive una aventura auténtica en el corazón del desierto. Circuitos 4x4 y treks guiados por expertos saharauis.",
        cta: "Descubre nuestros circuitos",
        scroll: "Desplazar"
      },
      circuits: {
        title: "Nuestras Aventuras",
        subtitle: "Explora el Sahara a tu ritmo",
        intro: "Durante más de 20 años, hemos recorrido los caminos del gran sur marroquí. Nuestros circuitos te llevan desde las puertas de Marrakech hasta las majestuosas dunas de Erg Chegaga, a través de los valles del Draa, gargantas espectaculares y oasis escondidos. Cada itinerario está diseñado para revelarte el alma auténtica del Sahara, lejos de las rutas turísticas.",
        all: "Todos",
        type4x4: "4x4",
        typeTrekking: "Trekking",
        duration: "días",
        from: "Desde",
        perPerson: "por persona",
        viewDetails: "Ver detalles",
        difficulty: {
          easy: "Fácil",
          moderate: "Moderado",
          challenging: "Desafiante"
        },
        includes: "Qué incluye",
        itinerary: "Itinerario",
        day: "Día",
        highlights: "Puntos destacados",
        bookNow: "Reservar ahora",
        maxGroup: "Grupo máx",
        persons: "personas",
        departure: "Salida desde"
      },
      team: {
        title: "Nuestro Equipo",
        subtitle: "Apasionados del desierto a tu servicio",
        intro: "Nacidos en el desierto y criados con sus misterios, nuestros guías son verdaderos hijos del Sahara. Su conocimiento íntimo de las dunas, su respeto por las tradiciones nómadas y su pasión contagiosa hacen de cada viaje una experiencia humana inolvidable. Con ellos, no serás un simple turista, sino un invitado privilegiado en su tierra de arena y estrellas.",
        experience: "años de experiencia"
      },
      testimonials: {
        title: "Lo que dicen",
        subtitle: "Comentarios de nuestros viajeros",
        intro: "Cada viaje deja una huella única. Descubre los testimonios de quienes han vivido la aventura sahariana con nosotros: desde familias hasta aventureros solitarios, fotógrafos en busca de luz hasta buscadores de serenidad. Sus palabras cuentan mejor que nosotros la magia de las noches estrelladas, la calidez de la hospitalidad bereber y el asombro ante la inmensidad dorada de las dunas."
      },
      contact: {
        title: "Contáctanos",
        subtitle: "¿Una pregunta? ¿Un proyecto de viaje?",
        intro: "Nuestro equipo está a tu disposición para construir juntos tu viaje ideal. Ya sea que desees un circuito personalizado, información sobre nuestras salidas o simplemente consejos para preparar tu aventura, no dudes en escribirnos. Generalmente respondemos en 24 horas y estaremos encantados de ayudarte a preparar tu estancia en el Sahara.",
        name: "Tu nombre",
        email: "Tu email",
        phone: "Teléfono",
        subject: "Asunto",
        message: "Tu mensaje",
        send: "Enviar",
        success: "¡Mensaje enviado con éxito!",
        error: "Error al enviar"
      },
      booking: {
        title: "Reserva",
        participants: "Número de participantes",
        date: "Fecha preferida",
        specialRequests: "Solicitudes especiales",
        total: "Total",
        payNow: "Pagar ahora",
        paymentSuccess: "¡Pago exitoso!",
        paymentPending: "Pago en curso...",
        paymentError: "Error de pago",
        confirmationMessage: "Tu reserva está confirmada. Recibirás un email de confirmación."
      },
      map: {
        title: "Mapa del Sahara",
        subtitle: "Explora nuestras rutas",
        intro: "Desde la ciudad ocre de Marrakech hasta las inmensas dunas de Erg Chegaga, explora visualmente nuestros territorios de aventura. Este mapa interactivo te permite descubrir las etapas clave de nuestros circuitos: kasbahs milenarias, valles verdes, pueblos nómadas y mares de arena. Haz clic en un itinerario para descubrir detalles y planificar tu próxima escapada sahariana.",
        routes: "Rutas",
        destinations: "Destinos",
        city: "Ciudad",
        village: "Pueblo",
        dunes: "Dunas",
        kasbah: "Kasbah",
        valley: "Valle",
        gorge: "Gargantas"
      },
      footer: {
        tagline: "La aventura auténtica del Sahara marroquí",
        quickLinks: "Enlaces Rápidos",
        contact: "Contacto",
        followUs: "Síguenos",
        rights: "Todos los derechos reservados"
      },
      common: {
        loading: "Cargando...",
        error: "Ocurrió un error",
        retry: "Reintentar",
        close: "Cerrar",
        back: "Volver"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
